import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges, SimpleChange, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../services/global.service';
declare var AdobeDC: any;

@Component({
    selector: 'app-files-slider',
    templateUrl: './files-slider.component.html',
    styleUrls: ['./files-slider.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilesSliderComponent implements OnInit {

	@Input() filesList: any;
	@Input() urlProperty: string = 'file_url';
	@Input() fileNameProperty: string = 'file_name';
	@Input() position: number = 0;
	@Input() userId: string;
	@Input() editable: boolean;
	@Input() showEditButton: boolean = false;
	@Input() type: string;
	@Output() closeView = new EventEmitter<any>();
	@Output() onChangeSlide = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	view: string = '';
	loading: boolean;
	adobeDCView;

	next() {
		if (this.position + 1 == this.filesList.length) {
			this.position = 0;
		} else {
			this.position++;
		}
		this.onChangeSlide.emit(this.position);
		if (this._gS.getFileType(this.filesList[this.position].fileExtension) == 'pdf') {
			this.setPdfViewer(this.filesList[this.position]);
		}
	}
	previous() {
		if (this.position == 0) {
			this.position = this.filesList.length - 1;
		} else {
			this.position--;
		}
		this.onChangeSlide.emit(this.position);
		if (this._gS.getFileType(this.filesList[this.position].fileExtension) == 'pdf') {
			this.setPdfViewer(this.filesList[this.position]);
		}
	}
	loadImage() {

	}
	close() {
		this.closeView.emit()
	}
	delete() {
		this.view = 'delete'
	}
	deleteConfirm() {
		this.notify.emit({ position: this.position, type: "delete" })
	}
	edit() {
		this.notify.emit({ position: this.position, type: "edit" })
	}

	setPdfViewer(fileItem) {
		setTimeout(() => {
			this.adobeDCView = new AdobeDC.View({ clientId: this._gS.adobe_cred, divId: `adobe-dc-view`, locale: "en-US" });

			var promise = this.adobeDCView.previewFile({
				content: { location: { url: fileItem[this.urlProperty] } },
				metaData: { fileName: fileItem[this.fileNameProperty] ? fileItem[this.fileNameProperty] : 'document.pdf' }
			}, { embedMode: "SIZED_CONTAINER", showFullScreen: false });
		}, 50)
	}

	setFilesExtensions() {
		for (const file of this.filesList) {
			file.fileExtension = this._gS.getFileExtension(file[this.fileNameProperty]);
		}
	}

	constructor(public _gS: GlobalService) { }

	ngOnInit() {
		if (this._gS.getFileType(this.filesList[this.position].fileExtension) == 'pdf') {
			this.setPdfViewer(this.filesList[this.position]);
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.filesList) {
			this.setFilesExtensions();
		}
	}

}
